import React from "react";

const Member = React.createContext({
  _refresh: () => null,
  member: {},
});

export default Member;
